// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"254":"85916ddc","911":"f973f017"}[chunkId] + ".chunk.css";
};